import Vue from 'vue'
import VueRouter from 'vue-router'
import { checkAuth } from '@/utils/utils.router'

import {
  Exams,
  Exam,
  NewExam,
  NewStudents,
  EditExam,
  Login,
  NewExaminer
} from '@/views/examiner'
import NotFound from '@/views/NotFound'
import UserProfile from '@/views/examiner/UserProfile'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: { name: 'Exams' }
  },
  {
    path: '/exams',
    name: 'Exams',
    component: Exams
  },
  {
    path: '/room/:id',
    name: 'Exam',
    component: Exam,
    props: true
  },
  {
    path: '/new-exam',
    name: 'NewExam',
    component: NewExam
  },
  {
    path: '/new-students',
    name: 'NewStudents',
    component: NewStudents
  },
  {
    path: '/new-examiner',
    name: 'NewExaminer',
    component: NewExaminer
  },
  {
    path: '/exam/:id/edit',
    name: 'EditExam',
    component: EditExam,
    props: true
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/profile',
    name: 'Profile',
    component: UserProfile
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '/*',
    redirect: { name: 'NotFound' }
  }
]

const router = new VueRouter({
  base: '/app/',
  mode: 'history',
  routes
})

router.beforeEach(async (to, from, next) => {
  const publicPaths = ['/login']
  const authRequired = !publicPaths.includes(to.path)

  if (authRequired) {
    const loggedIn = await checkAuth()
    if (!loggedIn) return next({ name: 'Login' })
  }
  next()
})

export default router
